import React from 'react';

// "Strata B" mark — three stacked slabs forming a B. Placeholder until the
// owner picks from the logo canvas; swap the paths, keep the API.
export default function Logo({ className = 'h-8 w-8', mono = false }) {
  const a = mono ? 'currentColor' : '#F3F5F9';
  const b = mono ? 'currentColor' : '#5EA0FF';
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <rect x="10" y="8" width="36" height="14" rx="4" fill={a} />
      <rect x="10" y="25" width="42" height="14" rx="4" fill={b} />
      <rect x="10" y="42" width="34" height="14" rx="4" fill={a} />
      <rect x="10" y="8" width="10" height="48" rx="3" fill={a} />
    </svg>
  );
}
